module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAALZJREFUWEftmEEOgCAMBNt/6ev1XzUmnggYW6oEM54trMssFVQme3QyvYLgt1cszWEz20RkaQjeVXXN+JhMwXYnSFVT5koZ5BRqZgiurRgOtziG4d4th9A1HCR0ntBFuuNQhyPcI9iJhLud4/AQhyPpjQQoUlNFIjLQVzUIHsWwe7sBCRGp/UPDMAwXDoAESIDE5QCNg8ZRhAEk/o6E+/o/eKxyz5N2au69THxaj+CnTkXfm87hA7Y2TjwCJ3QVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/download.png
// module id = fXyP
// module chunks = 1